<template>
    <div>
        <div class="history-header" v-if="userData.id === object.supervisor.id">
            <a href class="btn btn--sm btn--round" data-target="#modalHistory" data-toggle="modal" @click="setHistoryObjectData()">Добавить историю</a>
        </div>
        <div class="history-body panel-group accordion" role="tablist" id="accordion" v-if="histories.length">

            <div class="history d-flex" v-for="(history, index) in paginatedData">
                <div class="info_avatar">
                    <a :href="`/volunteer/${history.user_id}/profile`" v-if="history.user">
                        <img class="media-object" v-if="history.user.avatar" :src="'/storage' + history.user.avatar.path.replace('original', 'avatar')" :alt="history.user.name">
                        <span class="info_avatar-name" v-else v-text="getUserPM(history.user.name)" :style="{background: history.user.avatar ? 'transparent' : '#2E76E4'}"></span>
                    </a>
                    <span v-else>
                        <span class="info_avatar-name" v-text="getUserPM('Anonymous')"></span>
                    </span>
                </div>

                <div class="history-content">
                         <span class="history__icon">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.69918 12.9417C1.55236 13.0577 1.52638 13.2417 1.57884 13.3875C1.63138 13.5335 1.76753 13.6526 1.95178 13.6273C3.24125 13.4499 4.45818 13.0942 5.60154 12.5602C6.44068 12.8287 7.33783 12.9682 8.25806 12.9682C12.2679 12.9682 15.5661 10.3122 15.5661 6.9591C15.5661 3.606 12.2679 0.95 8.25806 0.95C4.24822 0.95 0.95 3.606 0.95 6.9591C0.95 8.47497 1.63109 9.89396 2.82479 10.9829C2.79523 11.7156 2.43156 12.3626 1.69918 12.9417ZM5.68465 11.791C5.60278 11.7633 5.51448 11.7689 5.4363 11.8064C4.65123 12.1835 3.82847 12.471 2.96762 12.6691C3.35892 12.1068 3.54945 11.4788 3.5303 10.792C3.5272 10.6812 3.47953 10.5762 3.3982 10.5059C2.27878 9.53787 1.65484 8.28219 1.65484 6.9591C1.65484 4.09651 4.58384 1.71212 8.25806 1.71212C11.9323 1.71212 14.8613 4.09651 14.8613 6.9591C14.8613 9.82169 11.9323 12.2061 8.25806 12.2061C7.36191 12.2061 6.49143 12.0636 5.68465 11.791Z" fill="#6C4DBB" stroke="#6C4DBB" stroke-width="0.1"/>
                            </svg>
                        </span>
                    <a :href="`/volunteer/${history.user_id}/profile`" class="history__name" v-if="history.user">{{ history.user.name }}</a>
                    <span class="history__name" v-else>Anonymous</span>
                    добавил историю
                    <span class="history__event">"{{ history.title }}"</span>
                    <div>
                        <a href="#" class="history-link" data-toggle="modal" data-target="#historiesModal-histories"
                           @click="openModalHistory(history.title, history.id)">Читать</a>
                    </div>

                    <span class="time">Добавлено: {{ moment(history.created_at).format('DD.MM.YYYY') }}</span>
                </div>

                <history-modal :modal-item="modalItem" title="histories"/>

            </div>
            <div class="pagination-area" v-if="pageCount > 1">
                <button
                    class="pagination-area__btn"
                    :disabled="pageNumber === 0"
                    @click="prevPage">
                    <span class="lnr lnr-arrow-left"></span>
                </button>
                <button
                    class="pagination-area__btn"
                    :disabled="pageNumber >= pageCount -1"
                    @click="nextPage">
                    <span class="lnr lnr-arrow-right"></span>
                </button>
            </div>
        </div>
        <div class="tab-empty d-flex" v-else>Пока что здесь нет историй!</div>
    </div>

</template>

<script>

import HistoryModal from './PetAndProjectHistoriesModal'
import 'lightslider/dist/js/lightslider.min';
import 'lightslider/dist/css/lightslider.min.css'
import {mapGetters} from "vuex";

export default {
    name: "PetAndProjectHistoriesTabComponent",
    props: ['object'],
    data() {
        return {
            moment: window.moment,
            appRoutes: null,
            transactionsList: [],
            pageNumber: 0,
            size: 5,
            payForm: {
                activeSum: 20,
                email: null,
                tips: -1,
                autoPay: false
            },
            modalItem: {},
            loading: false,
        }
    },
    created() {
        this.appRoutes = window.appRoutes;
    },
    computed: {
        ...mapGetters({ histories: 'getterHistories' }),
        userData() {
            return this.$store.getters.getUserData;
        },
        pageCount() {
            if (!this.histories || !this.histories.length) return false

            let l = this.histories.length,
                s = this.size;
            return Math.ceil(l / s);
        },
        paginatedData() {
            if (!this.histories || !this.histories.length) return false

            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.histories.slice(start, end);
        },
    },
    methods: {

        getUserPM(name) {
            if (!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
        paginateClickCallback(pageNum) {
            this.page = pageNum;
        },
        openModalHistory(title, id) {
            return this.modalItem = this.histories.find(history => history.title === title && history.id === id)
        },

        nextPage() {
            this.pageNumber++;
        },
        prevPage() {
            this.pageNumber--;
        },
        setHistoryObjectData() {
            this.historyRequestStatus = 'waiting_to_send';
        },
    },
    components: {
        HistoryModal,
    },
}
</script>

<style lang="scss" scoped>


.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


.history {
    color: #929292;
    overflow: hidden;
    padding: 20px 30px;
    border-bottom: 1px solid #ececec;
    position: relative;
}

.history .info_avatar {
    position: relative;
    width: 50px;
    min-width: 50px;
    line-height: 50px;
    height: 50px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 16px;
    flex-shrink: 0;
}

.history-content {
    position: relative;
    padding-right: 40px;
    flex-grow: 1;
}

.history__icon {
    position: absolute;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    right: 0;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f1f2f4;
}

.history__name {
    font-weight: 700;
    color: #333;
}

.history__event {
    font-weight: 700;
    color: #007bff;
}

.history .info_avatar img {
    width: 100%;
    height: auto;
}

.history .info_avatar-name {
    position: absolute;
    left: 1px;
    bottom: 1px;
    right: 1px;
    top: 1px;
    border-radius: 50%;
    background: #2E76E4;
    z-index: 1;
}

.history-header {
    margin: 10px 0;
    padding: 0 15px;
    text-align: right;
}

.history-body {
    margin-top: 10px;
}

.history-body--loader {
    display: flex;
    flex-direction: row nowrap;
    justify-content: center;
    align-items: center;
    min-height: 200px;
}

.pagination-area {
    padding: 15px 0 0;
}

.pagination-area__btn {
    background: #ececec;
    border: none;
    line-height: 30px;
    width: 30px;
    height: 30px;
    box-shadow: none;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px;
}

.pagination-area__btn span {
    vertical-align: middle;
}

.tab-empty {
    justify-content: center;
    align-items: center;
    height: 200px;
    padding: 10px;
    text-align: center;
}

.panel-group {
    padding: 15px;
}

.history-link {
    font-weight: 700;
    color: #007bff;
    transition: .2s ease opacity;

    &:hover {
        opacity: .8;
    }
}


.photos {
    margin: 0 -5px;
    flex-wrap: wrap;


    &__image {
        width: calc(20% - 10px);
        height: 100px;
        margin: 5px;
        background: transparent no-repeat center/cover;
    }
}

@media screen and (max-width: 992px) {
    #modalHistory .btn {
        max-width: 300px;
        display: block;
        margin: 0 auto;
    }
}

@media screen and (max-width: 768px) {

    .history {
        flex-direction: column;
        align-items: center;
    }

    .history .info_avatar {
        margin-right: 0;
        margin-bottom: 20px;
    }

    .history-content {
        width: 100%;
    }

    .history-link {
        font-size: 14px;
        line-height: 16px;
    }

    .history-header {
        text-align: center;
    }
    .photos__image {
        width: calc(33.33% - 10px);
        height: 150px;
    }

    .rating_field label {
        font-size: 12px;
        line-height: 14px;
    }
}

@media screen and (max-width: 500px) {
    .photos__image {
        width: calc(50% - 10px);
        height: 150px;
    }
    #modalHistory .btn {
        max-width: 250px;
    }
}


</style>
